import { Injectable, Injector, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { STORAGE_TYPE } from './storage.enum';
import { StorageFactory } from './storage.factory';
import { StorageInterface } from './storage.interface';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private readonly injector = inject(Injector);

  public set<T>(storageType: STORAGE_TYPE, key: string, value: T): void {
    const storageService = this.injectService(storageType);
    storageService.set<T>(key, value);
  }

  public get<T>(storageType: STORAGE_TYPE, key: string): T | null {
    const storageService = this.injectService(storageType);
    return storageService.get<T>(key);
  }

  public remove(storageType: STORAGE_TYPE, key: string): void {
    const storageService = this.injectService(storageType);
    storageService.remove(key);
  }

  public observe<T>(storageType: STORAGE_TYPE, key: string): Observable<T> | undefined {
    const storageService = this.injectService(storageType);
    return storageService.observe ? storageService.observe<T>(key) : undefined;
  }

  private injectService(storageType: STORAGE_TYPE): StorageInterface {
    const injectable = StorageFactory.new(storageType);
    return this.injector.get<StorageInterface>(injectable);
  }
}
